/* src/app/modules/accounting/reports/report-gross-margin/report-gross-margin.component.css */
:host {
  --gm-brand: #e3fd64;
  --gm-brand-d: #4d7a00;
  --gm-text: #1a1d23;
  --gm-muted: #6b7280;
  --gm-border: #e5e7eb;
  --gm-surface: #ffffff;
  --gm-radius: 10px;
  --gm-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.gm-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.gm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.gm-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.gm-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.gm-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.gm-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--gm-text);
  line-height: 1.2;
}
.gm-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--gm-muted);
}
.gm-toggle-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: var(--gm-surface);
  border: 1px solid var(--gm-border);
  border-radius: var(--gm-radius);
  box-shadow: var(--gm-shadow);
  width: fit-content;
}
.gm-toggle-card mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--gm-brand);
}
.gm-toggle-label {
  font-size: 13.5px;
  color: var(--gm-text);
  font-weight: 500;
}
.gm-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.gm-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.gm-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--gm-brand);
}
.gm-loading__dots {
  display: flex;
  gap: 8px;
}
.gm-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--gm-brand);
  opacity: 0.3;
  animation: gm-pulse 1.2s ease-in-out infinite;
}
.gm-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.gm-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes gm-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.gm-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--gm-muted);
}
.gm-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
@media (max-width: 700px) {
  .gm-kpi-grid {
    grid-template-columns: 1fr;
  }
}
.gm-kpi {
  background: var(--gm-surface);
  border: 1px solid var(--gm-border);
  border-radius: var(--gm-radius);
  box-shadow: var(--gm-shadow);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  overflow: hidden;
}
.gm-kpi::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gm-kpi-accent, var(--gm-border));
}
.gm-kpi--green {
  --gm-kpi-accent: #16a34a;
}
.gm-kpi--red {
  --gm-kpi-accent: #dc2626;
}
.gm-kpi--result {
  --gm-kpi-accent: var(--gm-kpi-result-color, #6b7280);
}
.gm-kpi__icon-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gm-kpi__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  flex-shrink: 0;
}
.gm-kpi__icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.gm-kpi--green .gm-kpi__icon {
  background: rgba(22, 163, 74, 0.1);
}
.gm-kpi--green .gm-kpi__icon mat-icon {
  color: #16a34a;
}
.gm-kpi--red .gm-kpi__icon {
  background: rgba(220, 38, 38, 0.1);
}
.gm-kpi--red .gm-kpi__icon mat-icon {
  color: #dc2626;
}
.gm-kpi--result .gm-kpi__icon {
  background: rgba(227, 253, 100, 0.1);
}
.gm-kpi--result .gm-kpi__icon mat-icon {
  color: var(--gm-brand);
}
.gm-kpi__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--gm-muted);
}
.gm-kpi__value {
  font-size: 26px;
  font-weight: 700;
  color: var(--gm-text);
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}
.gm-kpi--result .gm-kpi__value {
  color: var(--gm-kpi-result-color, var(--gm-text));
}
.gm-kpi__pct {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12.5px;
  font-weight: 600;
  width: fit-content;
}
.gm-kpi__pct--pos {
  background: rgba(22, 163, 74, 0.1);
  color: #15803d;
}
.gm-kpi__pct--neg {
  background: rgba(220, 38, 38, 0.1);
  color: #dc2626;
}
.gm-kpi__year {
  font-size: 12px;
  color: var(--gm-muted);
  margin-top: auto;
}
/*# sourceMappingURL=report-gross-margin.component.css.map */
